<p-dialog header="{{title}}" [(visible)]="display" [responsive]="true" showEffect="fade" [modal]="true" *ngIf="display" appendTo="body">

    <!-- #region BODY -->
    <div class="container-md">

        <div class="row mt-4 mb-4">
            <!-- DESCRIPTION -->
            <div class="col-sm-6">
                <label class="custom-label" i18n>
                    {{'general.description' | translate}}
                </label>
                <div class="p-0"></div>
                <textarea
                    pInputTextarea
                    id="observations"
                    [(ngModel)]="entity.description"
                    [rows]="5"
                    [style]="{ width: '250px' }"
                    [disabled]="!formManipulation"
                >
                </textarea>

							
            </div>
            <!-- VEHICLE -->
            <div class="col-sm-6">
                <strong><label for="insurance-vehicle" class="custom-label" i18n>{{'tableManagement.vehicle.vehicle' |
                    translate}} (*)</label></strong>
                <div class="p-0"></div>
                <p-dropdown [options]='vehicleList' [(ngModel)]='entity.vehicle'
                    placeholder="{{'general.select' | translate}} {{'tableManagement.vehicle.vehicle' | translate}}"
                    dataKey='id' optionLabel='name' [style]="{'width':'250px'}" appendTo='body' [filter]="true"
                    filterBy="name" (onChange)="onChangeVehicle($event)" (onFilter)="onFilterVehicle($event)"
                    [disabled]="true">
                </p-dropdown>
            </div>
        </div>
        <div class="row mt-4 mb-4">
            <div class="col-sm-6">
                <strong><label class="custom-label" i18n>
                    {{'tableManagement.notes.dateNote' | translate}} (*)
                </label></strong>
                <div class="p-0"></div>
                <p-calendar [(ngModel)]='noteDate' [showTime]='false' [style]="{'width':'200px'}"
                showIcon='true' appendTo='body' dateFormat='{{i18n.dateFormat}}'
                [disabled]="!formManipulation"></p-calendar>
            </div>

            <div class="col-sm-6">
                <label class="custom-label" i18n>{{ 'documents.form.file' | translate }}</label>
                <div class="d-flex align-items-center flex-wrap">
                    <!-- Input del archivo -->
                    
                    <input pInputText 
                           [readonly]='true' 
                           [ngModel]='entity.document?.document?.name'
                           [style]="{'flex': '1', 'margin-right': '10px'}"
                           class="form-control" />
                    
                    <!-- Botón para subir archivo -->
                    <button id="uploadDocumentButton" 
                            class="btn btn-outline-dark me-2"
                            (click)="uploadNoteInput.click()">
                        {{ '...'}}
                    </button>
            
                    <!-- Input oculto para subir archivo -->
                    <input #uploadNoteInput 
                           [hidden]="true" 
                           type="file" 
                           accept=".*"
                           [ngModel]="entity.document?.document?.name"
                           (change)="changeDocument($event)" />
            
                    <!-- Botón para descargar archivo -->
                    <button type="button" 
                            class="btn custom-table-download-button"
                            [disabled]="!this.entity.document"
                            (click)="downloadFile()">
                        <svg-icon src="assets/icons/download-button.svg"
                                  class="custom-table-download-button-icon"
                                  [svgStyle]="{ 'height.px': 25, 'width.px': 25 }"></svg-icon>
                    </button>                    
                </div>
            </div>
        </div>


    </div>
    <!-- #endregion BODY -->

    <!-- #region FOOTER -->
    <p-footer>
        <div class="d-flex justify-content-center align-items-center">
            <div class="p-2 d-flex align-items-center">
                <div *ngIf="isNew && formManipulation">
                    <button class="btn custom-button" (click)="createNote()" [disabled]="loading" i18n>
                        {{'general.create' | translate}}
                    </button>
                </div>
    
                <div *ngIf="!isNew && formManipulation">
                    <button class="btn custom-button" (click)="updateNote()" [disabled]="loading" i18n>
                        {{'general.save' | translate}}
                    </button>
                </div>
    
                <mat-spinner *ngIf="loading" [diameter]="30" strokeWidth="5" [color]="red" class="ms-2"> </mat-spinner>
            </div>
        </div>
    </p-footer>
    <!-- #endregion FOOTER -->
</p-dialog>